import { __rest } from "tslib";
import * as React from 'react';
import TongyongJiazai from './tongyong_jiazai';
import variables from '@web-common/styles/export.module.scss';
import classNames from 'classnames';
import './style.scss';
const Loading = props => {
    const { btnType = 'default', size = 'default', hasChildren } = props;
    const scale = React.useMemo(() => {
        if (size === 'mini') {
            return 0.75;
        }
        else if (size === 'small') {
            return 0.8;
        }
        else if (size === 'large') {
            return 0.95;
        }
        else {
            return 0.95;
        }
    }, [size]);
    const stroke = React.useMemo(() => {
        if (btnType === 'primary') {
            return '#FFFFFF';
        }
        else if (btnType === 'minorLine') {
            return variables.fill5;
        }
        else if (btnType === 'default') {
            return variables.brand3;
        }
        else if (btnType === 'danger') {
            return variables.error4;
        }
        else if (btnType === 'dashedLine') {
            return variables.fill5;
        }
        else if (btnType === 'link') {
            return variables.brand3;
        }
        else if (btnType === 'minorWhite') {
            return variables.text1;
        }
        else if (btnType === 'minorGray') {
            return variables.text1;
        }
        else {
            return variables.brand6;
        }
    }, [btnType]);
    return (React.createElement("span", { className: "loading-icon", style: { marginRight: hasChildren ? '3px' : '0' } },
        React.createElement(TongyongJiazai, { stroke: stroke, style: { transform: 'scale(' + scale + ')' } })));
};
const Button = props => {
    const { btnType, className, disabled, children, href, inline, size, loading } = props, restProps = __rest(props, ["btnType", "className", "disabled", "children", "href", "inline", "size", "loading"]);
    const classes = React.useMemo(() => classNames(`${variables.classPrefix}-btn`, className, {
        [`${variables.classPrefix}-btn-${btnType}`]: btnType,
        disabled: btnType === 'link' && disabled,
        inline: inline,
        [`${variables.classPrefix}-btn-size-${size}`]: size,
        [`${variables.classPrefix}-btn-loading`]: loading,
    }), [className, btnType, disabled, inline, size]);
    return (React.createElement(React.Fragment, null, btnType === 'link' && href ? (React.createElement("a", Object.assign({ className: classes, href: href }, restProps),
        loading && React.createElement(Loading, { btnType: btnType, size: size, hasChildren: !!children }),
        children)) : (React.createElement("button", Object.assign({ className: classes, disabled: disabled }, restProps),
        loading && React.createElement(Loading, { btnType: btnType, size: size, hasChildren: !!children }),
        children))));
};
Button.defaultProps = {
    disabled: false,
    btnType: 'default',
    inline: false,
    size: 'default',
    loading: false,
};
export default Button;
